import { render, staticRenderFns } from "./ShowComponent.vue?vue&type=template&id=67df8818"
import script from "./ShowComponent.vue?vue&type=script&lang=js"
export * from "./ShowComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports